export default __webpack_public_path__ + "static/media/m.9bff64b8.mp3";